/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { m, type Variants } from 'motion/react'
import { useInView } from 'react-intersection-observer'

const variants: Variants = {
	visible: {
		opacity: 1,
	},
	hidden: {
		opacity: 0,
	},
}

export const FadeInSection = ({ children }: { children: React.ReactNode }) => {
	const { ref: inViewRef, inView } = useInView({ threshold: 0.1 })
	return (
		<m.div
			ref={inViewRef}
			variants={variants}
			initial="hidden"
			animate={inView ? 'visible' : 'hidden'}
			exit="hidden"
			transition={{ duration: 0.7 }}
		>
			{children}
		</m.div>
	)
}
